import gql from 'graphql-tag';
import { graphql } from '@apollo/react-hoc';
import { SimpleLoadingComponent } from '../../utils/apollo';
import addTravelPlan from '../../mutations/RepVisitsTravelPlan/addTravelPlan';
import Availability from './availability';

const query = gql`
  query HighSchoolBySchoolId($id: String!) {
    highSchoolBySchoolId(id: $id) {
      id
      name
      isOnViewersTravelPlan
      hasCollegeFairs
      hasRepVisits
    }
  }
`;

const graphqlData = graphql(query, {
  options: ({ params }) => {
    const { id } = params;
    return {
      variables: {
        id,
      },
      fetchPolicy: 'cache-and-network',
    };
  },
});
const addTravelPlanMutation = graphql(addTravelPlan, {
  name: 'addTravelPlan',
  options: ({ schoolId: id }) => ({
    refetchQueries: [{ query, variables: { id } }],
    awaitRefetchQueries: true,
  }),
});

export default SimpleLoadingComponent(graphqlData, addTravelPlanMutation)(Availability);
